<section class="toggle-form" [ngClass]="{ active: isBulkUserReplacementSliderOpen }">
  <div class="formwrap">
      <div class="header">
        <h2>
          <b>{{ topBarTitle }}</b>
        </h2>
        <p-button appPreventDoubleClick styleClass="p-button-text" id="bulkUserReplacementSliderCloseButton"
          type="button" label="Close" (debounceClick)="closeConfirmation()"></p-button>
      </div>
      <div class="general-container content">
        <div class="fields-row">
          <div class="field field-required">
            <bpt-dropdown label="Assignment(s)" 
              [options]="assignmentList ?? []" 
              [multiSelect]="true" 
              [editable]="false"
              [(ngModel)]="selectedAssignments" 
              (dropdownChange)="validateUserInput()" 
              id="assignments"
              [showClear]="true" 
              [showFilter]="true" 
              [valueField]="valueField" 
              [labelField]="labelField"
              [ngClass]="{ 'error-highlight': mandatoryFields.assignments }" 
              [required]="true">
            </bpt-dropdown>
          </div>
        </div>
        <div class="fields-row">
          <div class="field field-required">
            <div class="flex card-container">
              <div class="label-wrapper">
                <label>User to Remove</label>
              </div>
              <div class="flex flex-row scope-wrapper">
                <div class="tree-wrapper">
                  <p-treeSelect
                    selectionMode="single"
                    class="w-full"
                    [(ngModel)]="selectedUserToRemove"
                    [options]="treeData"
                    [style]="{ 'width': '100%' }"
                    [ngClass]="{'red': terminatedUserSelected, 'green':activeUserSelected}"
                    (onNodeSelect)="handleTreeSelectChange($event)"
                    [filter]="true"
                    inputId="on_label"
                    ></p-treeSelect>
                </div>
              </div>  
            </div>
          </div>
        </div>
        <div class="fields-row">
          <div class="field field-required">
            <bpt-dropdown label="User to Add" 
              [options]="usersToAddList ?? []" 
              [multiSelect]="false" 
              [editable]="false"
              [(ngModel)]="selectedUserToAdd" 
              (dropdownChange)="validateUserInput()" 
              id="userToAdd" 
              [showClear]="true"
              [showFilter]="true" 
              [valueField]="labelField"
              [labelField]="labelField"
              [ngClass]="{ 'error-highlight': mandatoryFields.usersToAdd }" 
              [required]="true">
            </bpt-dropdown>
          </div>
        </div>
      </div>
      <div>
        <p-button appPreventDoubleClick 
          label="Save" 
          type="submit" 
          id="bulkUserReplacementSaveButton"
          class="align-right" 
          styleClass="bpt-button-compact" 
          (debounceClick)="updateUserRequirement()"
          [disabled]="!validInput">
        </p-button>
      </div>

  </div>
</section>